import React from 'react'
import { Box } from '@fundamentals'
import { Tooltip } from '@common/material'
import { useNavigationContext } from '@common/hooks'
import { UserProfileCard } from './UserProfileCard'
import {
  ExternalUser,
  ExternalUserProfileCard,
} from './ExternalUserProfileCard'

type UserProfileHoverWrapperProps = {
  userId: number | undefined
  organisationId?: number
  lastBriefedOn?: string
  // Shown as a "No SiteAssist account" card when there is no userId
  externalUser?: ExternalUser
  children: React.ReactNode
}

export const UserProfileHoverWrapper: React.FC<
  UserProfileHoverWrapperProps
> = ({ userId, organisationId, lastBriefedOn, externalUser, children }) => {
  const { organisationId: contextOrgId, projectId: contextProjectId } =
    useNavigationContext()
  const resolvedOrganisationId = organisationId ?? contextOrgId

  let card: React.ReactNode = null
  if (userId && resolvedOrganisationId) {
    card = (
      <UserProfileCard
        userId={userId}
        organisationId={resolvedOrganisationId}
        projectId={contextProjectId || undefined}
        lastBriefedOn={lastBriefedOn}
      />
    )
  } else if (!userId && externalUser) {
    card = (
      <ExternalUserProfileCard
        user={externalUser}
        lastBriefedOn={lastBriefedOn}
      />
    )
  }

  if (!card) return <>{children}</>

  return (
    <Tooltip
      placement='right-start'
      enterDelay={500}
      title={card}
      slotProps={{
        tooltip: {
          sx: { bgcolor: 'transparent', p: 0, m: 0, maxWidth: 'none' },
        },
        arrow: { sx: { color: 'common.white' } },
      }}
    >
      <Box component='span' sx={{ display: 'inline-flex' }}>
        {children}
      </Box>
    </Tooltip>
  )
}
